(function () {
  'use strict';

  var PROP_SELECTOR = '[name^="properties["]';

  // Properties are only attached if at least one of these keys is present.
  var REQUIRED_KEYS = ['_clc_product', 'clc_product', 'Returns Policy'];

  // If this input is present in the scope, properties are suppressed entirely
  // UNLESS the add-to-cart came from the Adapt button below.
  var MONOGRAM_SELECTOR = '[name="properties[Monogram Fee]"]';

  // The only trigger allowed to send full properties on a monogram product.
  var ADAPT_SELECTOR = '.adpt_addtocart';

  // A trigger with this class sends no line-item properties at all.
  var NO_RETURNS_SELECTOR = '.not_add_Returns_Policy';

  // A trigger with this class sends exactly one property and nothing else.
  var FINAL_SALE_SELECTOR = '.add_only_final_sale';
  var FINAL_SALE_PROPS = { 'Returns Policy': 'Final Sale' };

  // Buttons that trigger an add-to-cart in this theme
  var TRIGGER_SELECTOR = [
    '.js-quick-buy-add-to-bag',
    '.js-hero-product-add-to-bag',
    '.js-add-to-bag-cta',
    '[data-add-to-cart-text]',
    ADAPT_SELECTOR,
    NO_RETURNS_SELECTOR,
    FINAL_SALE_SELECTOR
  ].join(',');

  var CLICK_TTL = 8000; // ms
  var EMPTY_CLICK = {
    scope: null,
    time: 0,
    isAdapt: false,
    isNoReturns: false,
    isFinalSale: false
  };
  var lastClick = EMPTY_CLICK;

  /**
   * Walk up from the clicked button to the nearest ancestor that actually
   * contains properties[...] inputs. This keeps the hero buy box and the
   * quick-add drawer from reading each other's fields on a PDP.
   */
  function resolveScope(trigger) {
    var node = trigger;
    while (node && node !== document.body) {
      if (node.querySelector && node.querySelector(PROP_SELECTOR)) return node;
      node = node.parentElement;
    }
    return null;
  }

  function collectProperties(scope) {
    var props = {};
    if (!scope) return props;

    var nodes = scope.querySelectorAll(PROP_SELECTOR);
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];

      if (el.disabled) continue;
      if ((el.type === 'checkbox' || el.type === 'radio') && !el.checked) continue;

      var match = el.name.match(/^properties\[(.+)\]$/);
      if (!match) continue;

      var key = match[1].trim();
      var value = (el.value == null ? '' : String(el.value)).trim();

      // skip empty, and skip explicit falsey flags an app may render
      if (!key || value === '' || value === 'false') continue;

      props[key] = value;
    }
    return props;
  }

  // At least one of the required keys must be present, otherwise we send nothing.
  function hasRequiredKey(props) {
    for (var i = 0; i < REQUIRED_KEYS.length; i++) {
      if (Object.prototype.hasOwnProperty.call(props, REQUIRED_KEYS[i])) return true;
    }
    return false;
  }

  function hasMonogramFee(scope) {
    return !!(scope && scope.querySelector && scope.querySelector(MONOGRAM_SELECTOR));
  }

  // Remember the last add-to-cart click. Any other click clears it, so a
  // stale value can never leak into an unrelated add (e.g. a recommendation).
  document.addEventListener(
    'click',
    function (e) {
      var target = e.target && e.target.closest ? e.target : null;
      var trigger = target ? target.closest(TRIGGER_SELECTOR) : null;
      if (!trigger) {
        lastClick = EMPTY_CLICK;
        return;
      }
      lastClick = {
        scope: resolveScope(trigger),
        time: Date.now(),
        // true when the click came from the button itself or anything inside it
        isAdapt: !!target.closest(ADAPT_SELECTOR),
        isNoReturns: !!target.closest(NO_RETURNS_SELECTOR),
        isFinalSale: !!target.closest(FINAL_SALE_SELECTOR)
      };
    },
    true // capture, so we run before the theme's own handler
  );

  function patchBody(body) {
    var data;
    try {
      data = JSON.parse(body);
    } catch (err) {
      return body;
    }
    if (!data || typeof data !== 'object') return body;

    if (!lastClick.time || Date.now() - lastClick.time > CLICK_TTL) return body;

    var scope = lastClick.scope;
    var isAdapt = lastClick.isAdapt;
    var isNoReturns = lastClick.isNoReturns;
    var isFinalSale = lastClick.isFinalSale;
    lastClick = EMPTY_CLICK; // single-shot

    // Final sale gate: send exactly { "Returns Policy": "Final Sale" } and drop
    // everything else, whether it came from the form or from the caller.
    // No scope needed — the value is fixed, not read from the DOM.
    var replace = false;
    var props;

    if (isFinalSale) {
      props = FINAL_SALE_PROPS;
      replace = true;
    } else {
      if (!scope) return body;

      // Monogram gate: a Monogram Fee input means no properties at all,
      // unless this add came from .adpt_addtocart.
      if (hasMonogramFee(scope) && !isAdapt) return body;

      // Opt-out gate: this button sends the item with no properties at all.
      if (isNoReturns) return body;

      props = collectProperties(scope);

      // Gate: no _clc_product and no Returns Policy => add the item untouched.
      if (!hasRequiredKey(props)) return body;
    }

    function apply(item) {
      if (!item || typeof item !== 'object') return;

      var existing = replace ? {} : item.properties || {};
      var merged = {};

      // our collected props first...
      for (var k in props) {
        if (Object.prototype.hasOwnProperty.call(props, k)) merged[k] = props[k];
      }
      // ...then anything the caller already set overrides it
      for (var j in existing) {
        if (Object.prototype.hasOwnProperty.call(existing, j)) merged[j] = existing[j];
      }

      item.properties = merged;
    }

    if (Array.isArray(data.items)) data.items.forEach(apply);
    else apply(data);

    return JSON.stringify(data);
  }

  var nativeFetch = window.fetch;
  if (typeof nativeFetch !== 'function' || nativeFetch.__lineItemPropsPatched) return;

  window.fetch = function (input, init) {
    try {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      if (url.indexOf('/cart/add') !== -1 && init && typeof init.body === 'string') {
        var patched = {};
        for (var k in init) {
          if (Object.prototype.hasOwnProperty.call(init, k)) patched[k] = init[k];
        }
        patched.body = patchBody(init.body);
        return nativeFetch.call(this, input, patched);
      }
    } catch (err) {
      /* fall through to the untouched request */
    }
    return nativeFetch.apply(this, arguments);
  };

  window.fetch.__lineItemPropsPatched = true;
})();